<template>
  <div class="tab-panel">
    <div class="house-buttons">
      <button type="button" @click="houseActive = '0'" :class="['house-btn', { active: houseActive === '0' }]">Resolutions</button>
      <button type="button" @click="houseActive = '1'" :class="['house-btn', { active: houseActive === '1' }]">Bills on First Reading</button>
      <button type="button" @click="houseActive = '2'" :class="['house-btn', { active: houseActive === '2' }]">Unnumbered Substitute Bill</button>
      <button type="button" @click="houseActive = '3'" :class="['house-btn', { active: houseActive === '3' }]">Committee Report / Substitute Bill</button>
      <button type="button" @click="houseActive = '4'" :class="['house-btn', { active: houseActive === '4' }]">Bills on Third Reading</button>
    </div>

    <div class="house-accordion">
      <!-- Resolutions -->
      <div v-show="houseActive === '0'" class="accordion-panel">
        <h4>Resolutions</h4>
        <div v-for="(resolution, num) in houseData.resolutions" :key="num" class="resolution-item">
          <div class="item-header">
            <h5>Resolution #{{ num + 1 }}</h5>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Resolution Title:</label>
              {{resolution.title}}
            </div>
            <div class="form-group">
              <label>Date Filed:</label>
              {{resolution.datefiled}}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Resolution No.:</label>
              {{resolution.no}}
            </div>
            <div class="form-group">
              <label>Referred to Committee:</label>
              {{ formatArray(resolution.committee) }}
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              {{ formatArray(resolution.authors) }}
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            {{ resolution.remarks }}
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            {{ resolution.salient_features }}
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
            </div>
            <div v-if="resolution.legisstatus?.length" v-for="(status, sidx) in resolution.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  {{ status.status }}
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  {{ status.date }}
                </div>
              </div>
            </div>
            <div v-else class="no-data">No legislative status available</div>
          </div>

        </div>
      <!-- Position Papers Section for Resolutions -->
        <PositionPaper
          :positionPapers="houseResolutionsPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusResolutions"
          @addPositionPaper="() => $emit('addPositionPaper', 'house', 'resolution')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'house', 'resolution', index)"
        />
      </div>

      <!-- Bills on First Reading -->
      <div v-show="houseActive === '1'" class="accordion-panel">
        <h4>Bills on First Reading</h4>
        <div v-for="(bill, num) in houseData.firstreading" :key="num" class="bill-item">
          <div class="item-header">
            <h5>Bill #{{ num + 1 }}</h5>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              {{bill.title}}
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              {{bill.shorttitle}}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>HB No.:</label>
              {{bill.no}}
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              {{ formatArray(bill.authors) }}
            </div>
            <div class="form-group">
              <label>Date Filed:</label>
              {{ bill.datefiled }}
            </div>
            <div class="form-group">
              <label>Referred to Committee:</label>
              {{ formatArray(bill.committee) }}
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            {{ bill.remarks }}
          </div>
          <div class="form-group">
            <label>Source/Link:</label>
            <a v-if="bill.source" :href="bill.source" target="_blank" class="link">{{ bill.source }}</a>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            {{ bill.salient_features }}
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
            </div>
            <div v-if="bill.legisstatus?.length" v-for="(status, sidx) in bill.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  {{status.status}}
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  {{ status.date }}
                </div>
              </div>
            </div>
            <div v-else class="no-data">No legislative status available</div>
          </div>


        </div>

        <!-- Position Papers Section for First Reading -->
        <PositionPaper 
          :positionPapers="houseFirstReadingPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusFirstReading"
          @addPositionPaper="() => $emit('addPositionPaper', 'house', 'first_reading')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'house', 'first_reading', index)"
        />
      </div>

      <!-- Unnumbered Substitute Bill -->
      <div v-show="houseActive === '2'" class="accordion-panel">
        <h4>Unnumbered Substitute Bill</h4>
        <div v-for="(bill, num) in houseData.unnumbered" :key="num" class="bill-item">
          <div class="item-header">
            <h5>Bill #{{ num + 1 }}</h5>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              {{bill.title}}
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              {{bill.shorttitle}}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Substituting Bills:</label>
              {{bill.substituting}}
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              {{ formatArray(bill.authors) }}
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            {{bill.remarks}}
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            {{bill.salient_features}}
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
            </div>
            <div v-if="bill.legisstatus?.length" v-for="(status, sidx) in bill.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  {{status.status}}
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  {{status.date}}
                </div>
              </div>
            </div>
            <div v-else class="no-data">No legislative status available</div>
          </div>

        </div>
        <!-- Position Papers Section for Unnumbered Bills -->
        <PositionPaper 
          :positionPapers="houseUnnumberedPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusFirstReading"
          @addPositionPaper="() => $emit('addPositionPaper', 'house', 'unnumbered')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'house', 'unnumbered', index)"
        />
      </div>

      <!-- Committee Report / Substitute Bill -->
      <div v-show="houseActive === '3'" class="accordion-panel">
        <h4>Committee Report / Substitute Bill</h4>
        <div class="bill-item">
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              {{houseData.committee.billtitle}}
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              {{houseData.committee.shorttitle}}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>HB No. / Committee Report:</label>
              {{houseData.committee.no}}
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              {{ formatArray(houseData.committee.authors) }}
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            {{houseData.committee.remarks}}
          </div>
          <div class="form-group">
            <label>Source/Link:</label>
            <a v-if="houseData.committee.source" :href="houseData.committee.source" target="_blank" class="link">{{ houseData.committee.source }}</a>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            {{houseData.committee.salient_features}}
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
            </div>
            <div v-if="houseData.committee.legisstatus?.length" v-for="(status, sidx) in houseData.committee.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  {{status.status}}
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  {{status.date}}
                </div>
              </div>
            </div>
            <div v-else class="no-data">No legislative status available</div>
          </div>

        </div>
        
        <!-- Position Papers Section for Committee Reports -->
        <PositionPaper 
          :positionPapers="houseCommitteePositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusCommitteeReport"
          @addPositionPaper="() => $emit('addPositionPaper', 'house', 'committee_report')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'house', 'committee_report', index)"
        />
      </div>

      <!-- Bills on Third Reading -->
      <div v-show="houseActive === '4'" class="accordion-panel">
        <h4>Bills on Third Reading</h4>
        <div class="bill-item">
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              {{houseData.thirdreading.billtitle}}
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              {{houseData.thirdreading.shorttitle}}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>HB No. / Committee Report:</label>
              {{houseData.thirdreading.no}}
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              {{ formatArray(houseData.thirdreading.authors) }}
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Remarks:</label>
              {{houseData.thirdreading.remarks}}
            </div>
            <div class="form-group">
              <label>Source/Link:</label>
              <a v-if="houseData.thirdreading.source" :href="houseData.thirdreading.source" target="_blank" class="link">{{ houseData.thirdreading.source }}</a>
            </div>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            {{houseData.thirdreading.salient_features}}
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
            </div>
            <div v-if="houseData.thirdreading.legisstatus?.length" v-for="(status, sidx) in houseData.thirdreading.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  {{status.status}}
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  {{status.date}}
                </div>
              </div>
            </div>
            <div v-else class="no-data">No legislative status available</div>
          </div>

        </div>
        
        <!-- Position Papers Section for Third Reading -->
        <PositionPaper 
          :positionPapers="houseThirdReadingPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusThirdReading"
          @addPositionPaper="() => $emit('addPositionPaper', 'house', 'third_reading')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'house', 'third_reading', index)"
        />
      </div>
    </div>

    <!-- Key Issues Section -->
    <KeyIssuesSection 
      :keyIssues="keyIssues"
      :activeTab="keyIssuesActive"
      :revenueStartYear="revenueStartYear"
      :revenueEndYear="revenueEndYear"
      :budgetaryStartYear="budgetaryStartYear"
      :budgetaryEndYear="budgetaryEndYear"
      @update:activeTab="keyIssuesActive = $event"
      @update:keyIssues="$emit('update:keyIssues', $event)"
      @addRevenueRow="$emit('addRevenueRow')"
      @addBudgetaryRow="$emit('addBudgetaryRow')"
      @addDofConcernsRow="$emit('addDofConcernsRow')"
      @deleteRevenueRow="$emit('deleteRevenueRow', $event)"
      @deleteBudgetaryRow="$emit('deleteBudgetaryRow', $event)"
      @deleteDofConcernsRow="$emit('deleteDofConcernsRow', $event)"
      @getYearTotal="$emit('getYearTotal', $event)"
      @autoResize="$emit('autoResize', $event)"
      @updateRevenueStartYear="$emit('updateRevenueStartYear', $event)"
      @updateRevenueEndYear="$emit('updateRevenueEndYear', $event)"
      @updateBudgetaryStartYear="$emit('updateBudgetaryStartYear', $event)"
      @updateBudgetaryEndYear="$emit('updateBudgetaryEndYear', $event)"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import KeyIssuesSection from './KeyIssuesSectionView.vue'
import PositionPaper from './PositionPaperView.vue'

const props = defineProps({
  houseData: {
    type: Object,
    required: true
  },
  keyIssues: {
    type: Object,
    required: true
  },
  referrals: {
    type: Array,
    default: () => []
  },
  authors: {
    type: Array,
    default: () => []
  },
  isSubButtonDisabled: {
    type: Boolean,
    default: false
  },
  revenueStartYear: {
    type: Number,
    default: () => new Date().getFullYear()
  },
  revenueEndYear: {
    type: Number,
    default: () => new Date().getFullYear() + 5
  },
  budgetaryStartYear: {
    type: Number,
    default: () => new Date().getFullYear()
  },
  budgetaryEndYear: {
    type: Number,
    default: () => new Date().getFullYear() + 5
  },
  positionPapers: {
    type: Array,
    default: () => []
  },
  houseActiveTab: {
    type: String,
    default: '0'
  }
})

const emit = defineEmits([
  'trackDeletedId',
  'addRevenueRow',
  'addBudgetaryRow', 
  'addDofConcernsRow',
  'deleteRevenueRow',
  'deleteBudgetaryRow',
  'deleteDofConcernsRow',
  'getYearTotal',
  'autoResize',
  'addPositionPaper',
  'deletePositionPaper',
  'update:keyIssues',
  'updateRevenueStartYear',
  'updateRevenueEndYear',
  'updateBudgetaryStartYear',
  'updateBudgetaryEndYear'
])

// Computed properties for filtered position papers
const houseResolutionsPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'house' && p.sub_type === 'resolution')
)
const houseFirstReadingPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'house' && p.sub_type === 'first_reading')
)
const houseUnnumberedPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'house' && p.sub_type === 'unnumbered')
)
const houseCommitteePositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'house' && p.sub_type === 'committee_report')
)
const houseThirdReadingPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'house' && p.sub_type === 'third_reading')
)

const houseActive = ref(props.houseActiveTab)
const keyIssuesActive = ref('revenue')

watch(() => props.houseActiveTab, (newValue) => {
  houseActive.value = newValue
})

const statusResolutions = [
  'Briefing',
  '1st Public Hearing',
  '2nd Public Hearing',
  '3rd Public Hearing',
  'TWG',
  'Approved/Adopted Resolutions'
];

const statusFirstReading = [
  '1st Briefing',
  '2nd Briefing',
  '3rd Briefing',
  '1st Public Hearing',
  '2nd Public Hearing',
  '3rd Public Hearing',
  'TWG',
  'Joint Committee Meeting',
  'Referral',
  'Approved with Ways and Means',
  'Approved with Appropriations'
];

const statusCommitteeReport = [
  'Period of Sponsorship',
  'Period of Interpellations',
  'Period of Amendments',
  'Approved on Second Reading'
];

const statusThirdReading = [
  'Approval on Third Reading',
  'Transmitted to Senate', 
];

const formatArray = (value) => {
  if (Array.isArray(value)) {
    return value.join(', ')
  }
  return value || '-'
}

</script>

<style scoped>
.house-buttons {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.house-btn {
  background: #f3f4f6;
  border: 2px solid #e5e7eb;
  color: #374151;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.85rem;
}

.house-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.house-btn.active {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border-color: #1e3a8a;
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
}

.accordion-panel {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 2px solid #e5e7eb;
  margin-bottom: 1rem;
}

.accordion-panel h4 {
  color: #1e3a8a;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #fbbf24;
}

.resolution-item, .bill-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.item-header h5 {
  color: #1e3a8a;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #1e3a8a;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1e3a8a;
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
}

.subsection {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.subsection-header h6 {
  color: #1e3a8a;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.status-item, .position-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.status-header, .position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.no-data {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.add-btn, .add-sub-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.add-btn:hover, .add-sub-btn:hover {
  background: linear-gradient(135deg, #047857 0%, #10b981 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.delete-btn, .delete-sub-btn {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.8rem;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.delete-btn:hover, .delete-sub-btn:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.delete-btn.disabled, .delete-sub-btn.disabled,
.add-btn.disabled, .add-sub-btn.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.delete-btn.disabled:hover, .delete-sub-btn.disabled:hover,
.add-btn.disabled:hover, .add-sub-btn.disabled:hover {
  background: #9ca3af;
  transform: none;
  box-shadow: none;
}

.link {
  word-wrap: break-word;
  word-break: break-all;
  overflow-wrap: break-word;
  hyphens: auto;
}

@media (max-width: 768px) {
  .house-buttons {
    flex-direction: column;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .subsection-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .status-header, .position-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>